import {Head} from '@inertiajs/react';
import HomeLayout from "@/Layouts/HomeLayout.jsx";
import Navbar from "@/components/FrontPages/Common/Navbar.jsx";
import HeroBanner from "@/components/FrontPages/Home/HeroBanner.jsx";
import Footer from "@/components/FrontPages/Common/Footer.jsx";

export default function Home() {
    return (
        <HomeLayout>
            <Head title="Welcome to YoungVoices!"/>
            <Navbar/>
            <HeroBanner/>
            <Footer/>
        </HomeLayout>
    );
}
